
(function ($, Drupal) {

  const lazyLoad = new LazyLoad();

  const touch = matchMedia('(hover: none)').matches;
  const mobile = window.matchMedia("(max-width: 819px)").matches;
  const desktop = window.matchMedia("(min-width: 820px)").matches;
  const APP = document.getElementById('app');

  let map;
  let bounds;



  $(document).ready(function () {

    //
    // GTM Tracking
    //

    function pushGtmEvent(event, target, name, page) {
      window.dataLayer.push({
        event: event,
        target: target,
        name: name,
        page: page
      });
    }

    const gtmCta = document.querySelectorAll('.js-gtm-cta');
    gtmCta.forEach(function (el) {
      el.addEventListener('click', function () {
        pushGtmEvent('click', el.getAttribute('data-gtm-target'), el.getAttribute('data-gtm-name'), window.location.href);
      });
    });


    //
    //== Geolocation
    //

    //== geolocation Topbar
    const locationMarker = '<span class="glyphicon glyphicon-map-marker" aria-hidden="true"></span>';
    const locationTopbarButton = $('#views-exposed-form-around-me-page .form-submit');
    locationTopbarButton.html(locationMarker);

    locationTopbarButton.on('click', function (e) {
      e.preventDefault();
      getLocation();
    });

    // geolocation aroundme-cta
    const aroundmeCta = $('.block-aroundme');

    aroundmeCta.on('click', function (e) {
      e.preventDefault();
      getLocation();
    });

    //== geolocation result page
    const locationSearchPage = $('.aroundme-cta__button');
    locationSearchPage.on('click', function (e) {
      e.preventDefault();
      getLocation();
    });

    function getLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(loadUrlPosition, errorPosition);
      } else {
        alert('Ce navigateur ne supporte pas la géolocalisation');
      }
    }

    function getLatLonFromUrl(url) {

      const urlObj = new URL(url);
      const params = new URLSearchParams(urlObj.search);

      // Extraction des paramètres imbriqués
      const latKey = 'prox[source_configuration][origin][lat]';
      const lonKey = 'prox[source_configuration][origin][lon]';

      const lat = params.get(latKey);
      const lon = params.get(lonKey);

      const hasCoordinates = lat !== null && lon !== null;

      return {lat: parseFloat(lat), lon: parseFloat(lon), hasCoordinates};
    }


    function loadUrlPosition(position) {

      /*const user_position = {
        'latitude': position.coords.latitude,
        'longitude': position.coords.longitude
      };

      localStorage.setItem('veggyplanet_user_position', JSON.stringify(user_position));*/
      //locationUrl = '/around-me?prox%5Bvalue%5D=200&prox%5Bsource_configuration%5D%5Borigin%5D%5Blat%5D=' + position.coords.latitude + '&prox%5Bsource_configuration%5D%5Borigin%5D%5Blon%5D=' + position.coords.longitude;
      const proximityLimit = 100;
      /*locationUrl = '/around-me?prox[value]=' + proximityLimit + '&prox[source_configuration][origin][lat]=' + position.coords.latitude + '&prox[source_configuration][origin][lon]=' + position.coords.longitude;*/
      const locationUrl = '/around-me?prox[source_configuration][origin][lat]=' + position.coords.latitude + '&prox[source_configuration][origin][lon]=' + position.coords.longitude;
      window.location.href = locationUrl;
    }

    function errorPosition(error) {
      var info = "Erreur lors de la géolocalisation : ";
      switch (error.code) {
        case error.TIMEOUT:
          info += "Timeout !";
          break;
        case error.PERMISSION_DENIED:
          info += "Vous n’avez pas donné la permission";
          break;
        case error.POSITION_UNAVAILABLE:
          info += "La position n’a pu être déterminée";
          break;
        case error.UNKNOWN_ERROR:
          info += "Erreur inconnue";
          break;
      }
      alert(info);
    }

    //
    //== Around me - map
    //
    if (document.querySelector('.path-around-me')) {

      const coordinates = getLatLonFromUrl(window.location.href);

      // si aucun résultats
      if (!coordinates.hasCoordinates) {

        //document.querySelector('.page-headings .lead').innerHTML = 'Aucun résultats, relancez une recherche : ';
        document.querySelector('.view-id-around_me .view-content ').style.display = 'none';

      } else {

        const mapAroundMe = document.getElementById('map');
        //const user_position = JSON.parse(localStorage.getItem('veggyplanet_user_position'));

        //map = displayMap(mapAroundMe, user_position.latitude, user_position.longitude, 'user');
        map = displayMap(mapAroundMe, coordinates.lat, coordinates.lon, 'user');

        //let markers = L.markerClusterGroup();
        //loadApiAroundMe()
        let restaurantsMarkers = [];

        function loadMarkersMap() {

          const restaurants = document.querySelectorAll('.js-restaurant-card');
          let restaurantsArr = [];

          restaurants.forEach(function (restaurant) {
            const restaurantObj = {};
            restaurantObj.id = restaurant.id;
            restaurantObj.title = restaurant.querySelector('.card-title').innerText;
            restaurantObj.url = restaurant.href;
            restaurantObj.cover = restaurant.querySelector('.card-cover img').src;
            restaurantObj.lat = restaurant.dataset.lat;
            restaurantObj.lon = restaurant.dataset.lon;
            restaurantsArr.push(restaurantObj);

          });

          // Ajout des marqueurs pour les restaurants
          restaurantsArr.forEach(restaurant => {

            const restaurantPopup = document.createElement('div');
            restaurantPopup.setAttribute('id', restaurant.id);
            //restaurantPopup.classList.add('card-content');
            restaurantPopup.innerHTML = '<div class="card-cover"><img src="' + restaurant.cover + '" class="img-responsive"></div>';
            restaurantPopup.innerHTML += '<div class="card-content"><h3 class="card-title">' + restaurant.title + '</h3></div>';
            restaurantPopup.innerHTML += '<div class="card-footer"><a class="btn" href="' + restaurant.url + '" target="_blank">Voir la fiche</a></div>';

            const marker = L.circleMarker([restaurant.lat, restaurant.lon], {radius: 10, color: '#91347b'}).addTo(map)
              .bindPopup(restaurantPopup);
            // ajout des marqueurs dans le groupe
            // markers.addLayer(marker);

            // Quand on clique sur le marker, scroll vers le résultat HTML correspondant
            marker.on('click', function () {
              const target = document.getElementById(restaurant.id);
              if (target) {
                target.scrollIntoView({behavior: 'smooth', block: 'center'});
                // mettre en évidence temporairement
                target.classList.add('restaurant-card--highlight');
                setTimeout(() => target.classList.remove('restaurant-card--highlight'), 2500);
              }
            });

            restaurantsMarkers.push(marker); // push des markers pour pouvoir les supprimer
            bounds.extend(marker.getLatLng());

          });


        }

        loadMarkersMap();
        // Ajuste la carte pour afficher tous les marqueurs
        map.fitBounds(bounds);


        //
        //== Relancer la recherche carte + fiches
        //
        let searchButton;

        function showSearchButton() {
          if (searchButton) return; // Ne pas recréer si déjà affiché

          searchButton = L.control({position: 'topright'});

          searchButton.onAdd = function () {
            const container = L.DomUtil.create('div', 'leaflet-bar leaflet-control leaflet-control-custom');
            container.innerHTML = '<button id="relaunch-search" class="btn btn-primary">Rechercher dans cette zone</button>';

            // Empêcher les clics de se propager à la carte
            L.DomEvent.disableClickPropagation(container);

            return container;
          };

          searchButton.addTo(map);

          // Ajouter l’événement clic
          setTimeout(() => {
            document.getElementById('relaunch-search').addEventListener('click', () => {

              clearRestaurantMarkers();

              const bounds = map.getBounds();
              const center = map.getCenter();

              // Exemple : rediriger avec les nouvelles coordonnées
              const newUrl = `/around-me?prox[source_configuration][origin][lat]=${center.lat}&prox[source_configuration][origin][lon]=${center.lng}`;
              //window.location.href = newUrl;
              const resultsContainer = document.querySelector('#js-results');

              fetch(newUrl)
                .then(response => {
                  return response.text();
                })
                .then(html => {
                  // Initialize the DOM parser
                  //const parser = new DOMParser();
                  // Parse the text
                  //const doc = parser.parseFromString(html, "text/html");
                  // You can now even select part of that html as you would in the regular DOM
                  // Example:
                  // const docArticle = doc.querySelector('article').innerHTML

                  const wrapper = document.createElement('div');
                  wrapper.innerHTML = html;

                  const newList = wrapper.querySelector('#js-results');
                  const itemResult = wrapper.querySelectorAll('.col');

                  if (itemResult.length > 0) {
                    //markers.clearLayers();
                    resultsContainer.innerHTML = newList.innerHTML;
                    loadMarkersMap();
                  } else {
                    resultsContainer.innerHTML = `<div class="warning">Aucun résultat trouvé.</div>`;
                    console.warn("Le contenu de la liste n'a pas été trouvé dans la réponse.");
                  }

                })
                .catch(error => {
                  console.error('Failed to fetch page: ', error);
                });

            });
          }, 100);
        }

        function clearRestaurantMarkers() {
          restaurantsMarkers.forEach(marker => map.removeLayer(marker));
          restaurantsMarkers = []; // Vide le tableau après suppression
        }

        showSearchButton();

        // afficher bouton relancer la recherche uniquement si carte bouge
        /*map.on('moveend', function () {
          showSearchButton();
        });*/

      }

    }


    async function loadApiAroundMe() {
      //const restaurant_id =
      // document.getElementsByTagName('article')[0].getAttribute('data-history-node-id')
      const aroundMe_api_url = '/api/around-me'; //+ restaurant_id
      const response = await fetch(aroundMe_api_url);
      const data = await response.json();
      return data;
      //console.log('data : ' + data)
    }


    //==

    $('#btn-search').on('click', function () {
      $('#block-search').slideToggle('fast');
      $('#edit-keys').focus();
    });


    //== Block recherche
    //
    $('#block-search .form-submit').html('<span class="glyphicon glyphicon-search" aria-hidden="true"></span>');
    $('#edit-submit-recherche--2').html('<span class="glyphicon glyphicon-search" aria-hidden="true"></span>');

    Drupal.behaviors.customSearchAutocomplete = {
      attach: function (context, settings) {
        $('#edit-requete', context).once('custom-autocomplete').each(function () {
          /*console.log('search : ', $(this));
          $(this).autocomplete("option", "appendTo", "#intro");*/

        });
      }
    };

    //
    // Page résultats recherche
    //
    // Affichage carte mobile
    const displaySearchMap_button = document.getElementById('displaySearchMap');
    let searchMap_already_opened = false;

    if (displaySearchMap_button) {
      displaySearchMap_button.addEventListener('click', function () {
        /* const mapResults = document.getElementById('leaflet-map-view-recherche-map')*/
        /* mapResults.style.display = 'block'
         if (!searchMap_already_opened) {
           mapResults.style.display = 'none'
         }*/
        //searchMap_already_opened = true
        APP.classList.toggle('is-active');
      });
    }

    // Au survol d'un restaurant changement de couleur de l'icône de la map
    const result = $('.view-id-recherche .col, .view-id-around_me .col');
    const marker = $('#leaflet-map-view-recherche-map .leaflet-interactive, #map .leaflet-interactive');
    result.hover(
      function () {
        const i = $(this).index(); // #Todo créer variable globale
        marker.eq(i).css({
          stroke: '#E831BC',
          fill: '#E831BC',
          fillOpacity: '1',
        });
      },
      function () {
        const i = $(this).index();
        marker.eq(i).css({
          stroke: '#91347b',
          fill: '#91347b',
          fillOpacity: '0.2',
        }).data();
      }
    );


    //
    // Pages restaurants
    //
    // Ajout d'une class localisée
    const restaurantsTile = $('.intro-title').text().trim();
    $('.intro-wrapper').addClass('restaurants-' + restaurantsTile);

    //
    // Page restaurant

    //
    //== Like vote - afficher pouce
    //
    /* var btnLike = $('#btn-like .up');
     btnLike.html('<span class="glyphicon glyphicon-thumbs-up like-icon" aria-hidden="true" title="I love it !"></span>');
     $('#btn-like .updown-score').append('Jaime(s)');*/

    // remercier pour le vote
    /* $('#btn-like .glyphicon').on('click', function () {
       $('.restaurant-content').prepend('<div class="action-message"><p>Votre vote à bien été pris en compte et sera effectif  au prochain affichage de la page.<br> Merci !</p></div>').show();
       $('.action-message').delay(4000).fadeOut();
       /!* setTimeout(function () {
          $('.action-message').hide();
        }, 3000)*!/
     })*/

    /* function incrementVote() {
       console.log('increment');
       let scoreWrapper = document.getElementsByClassName('updown-current-score');
       let count = scoreWrapper.textContent;
       count++;
       scoreWrapper.textContent = count;

       /!*  let value = parseInt(document.getElementsByClassName('updown-current-score').value);
         value = isNaN(value) ? 0 : value;
         value++;
         document.getElementsByClassName('updown-current-score').value = value;
         console.log('value');*!/
     }*/

    /*  document.querySelector('.up').onClick = incrementVote;*/


    function displayMap(mapEl, latitude, longitude, status) {

      //map = L.map(mapEl).setView([latitude, longitude], 13);

      const map = L.map(mapEl, {
        center: [latitude, longitude],
        zoom: 13,
        minZoom: 8,   // Empêche trop de dézoom
        maxZoom: 18   // Empêche trop de zoom
      });

      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 19, // limite fond de carte
        attribution: '© OpenStreetMap'
      }).addTo(map);

      // Création des limites pour ajuster la carte
      bounds = L.latLngBounds();

      let userMarker;
      if (status === 'user') {
        userMarker = L.marker([latitude, longitude]).addTo(map);
        /*.bindPopup("Vous êtes ici")
        .openPopup();*/
      } else {
        userMarker = L.circleMarker([latitude, longitude], {radius: 10, color: '#E831BC'}).addTo(map);
      }

      userMarker._icon.classList.add('marker-' + status);

      bounds.extend(userMarker.getLatLng());

      return map; // Très important pour réutiliser la carte après

    }

    //
    //== Map restaurant
    //

    if (document.querySelector('.page-node-type-restaurant')) {

      async function loadApiRestaurant() {
        const restaurant_id = document.getElementsByTagName('article')[0].getAttribute('data-history-node-id');
        const restaurant_api_url = '/api/restaurant/' + restaurant_id;
        const response = await fetch(restaurant_api_url);
        const data = await response.json();
        //console.log(data)
        return data;
      }

      var mapEl = document.getElementById('restaurant-map');

      function loadDesktopMap() {

        if (desktop) {


          mapSize();

          loadApiRestaurant()
            .then(data => {
              map = displayMap(mapEl, data[0].latitude, data[0].longitude);
            })
            .catch((err) => {
              console.log('error : ' + err);
            });

          // Hauteur de la carte en fonction de la couverture
          function mapSize() {
            const coverHeight = $('.restaurant-cover').height();
            mapEl.style.height = coverHeight + 'px';
          }

          window.onresize = mapSize;

        }

      }

      if (mapEl) {
        loadDesktopMap();
        window.onresize = loadDesktopMap;
      }


      // Affichage carte restaurant-mobile
      const displayMap_button = document.getElementById('displayMap');
      let already_opened = false;

      displayMap_button.addEventListener('click', function (el) {

        if (!already_opened) {

          already_opened = true;

          //const mapClone = mapEl.cloneNode(true);
          const modal = document.createElement("div");
          modal.classList.add('modal');
          modal.classList.add('modal-map');
          modal.classList.add('fade');
          modal.setAttribute('id', 'modalMap');

          const googleMapLink = '<a class="modal-map__link" href="https://www.google.com/maps?q=' + el.target.getAttribute('data-coord') + '" target="_blank">Ouvrir dans Google Map</a>';

          modal.innerHTML = '<div class="modal-dialog" role="document"><div class="modal-content"><div class="modal-body"><div id="mobileMap"></div></div><div class="modal-footer">' + googleMapLink + '<button type="button" class="btn btn-default" data-dismiss="modal">Fermer</button></div></div></div>';
          document.body.appendChild(modal);


          loadApiRestaurant()
            .then(data => {
              var mobileMapEl = document.getElementById('mobileMap');
              map = displayMap(mobileMapEl, data[0].latitude, data[0].longitude);
            })
            .catch((err) => {
              console.log('error : ' + err);
            });


          //const modalContent = document.querySelector('#modalMap .modal-body')
          // modalContent.appendChild(mapClone);
          //modal.innerText = "This is a paragraph";


        }

        $('#modalMap').modal('show');

      });

    }


    // Inscrire un restaurant - formulaire
    $('#edit-field-adresse-0-address-country-code--2').change(function () { // #Todo garder ?
      var country = $('#edit-field-adresse-0-address-country-code--2 :selected').val();
      $('#edit-field-pays-0-value--2').val(country);
    });

    // add organization label
    const organizationWrapper = document.querySelector('.js-form-item-field-adresse-0-address-organization');
    if (organizationWrapper) {
      const organizationLabel = document.createElement('label');
      organizationLabel.classList.add('control-label');
      organizationLabel.setAttribute('for', 'edit-field-adresse-0-address-organization');
      organizationLabel.textContent = 'Quel est le nom de votre établissement ?';
      organizationWrapper.prepend(organizationLabel);
    }


    //
    // Formulaire mettre à jour la fiche
    const restaurantTitleEl = document.getElementById('js-restaurant-title');
    if (restaurantTitleEl) {
      document.getElementById('js-update-listing').addEventListener('click', function () {
        document.getElementById('edit-subject-0-value').value = 'Mise à jour de la fiche "' + restaurantTitleEl.textContent + '"';
      });
    }


    /* Slider villes #Todo - pouvoir afficher plusieurs slider sur la même page
    -------------------------------------------------*/
    const splideThumbnails = document.querySelector('.splide-thumbnails');

    if (splideThumbnails) {

      var splide = new Splide(splideThumbnails, {
        type: 'loop',
        perPage: 4,
        perMove: 1,
        //drag: 'free',
        //snap: true,
        pagination: false,
        arrows: false,
        breakpoints: {
          992: {
            destroy: true
          }
        }
      });

      splide.mount();

      // Select the custom arrows
      const prevButton = document.querySelector('.slider-arrow--prev');
      const nextButton = document.querySelector('.slider-arrow--next');

      // Add event listeners to control Splide
      prevButton.addEventListener('click', () => splide.go('<')); // Go to previous slide
      nextButton.addEventListener('click', () => splide.go('>')); // Go to next slide

    }

  });

}(jQuery, Drupal));
